import { render, staticRenderFns } from "./PostHeadsUp.vue?vue&type=template&id=5bb0f94c&scoped=true&lang=html&"
import script from "./PostHeadsUp.vue?vue&type=script&lang=js&"
export * from "./PostHeadsUp.vue?vue&type=script&lang=js&"
import style0 from "./PostHeadsUp.vue?vue&type=style&index=0&id=5bb0f94c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb0f94c",
  null
  
)

export default component.exports